import { render, staticRenderFns } from "./Roll.vue?vue&type=template&id=695e0975&scoped=true&"
import script from "./Roll.vue?vue&type=script&lang=js&"
export * from "./Roll.vue?vue&type=script&lang=js&"
import style0 from "./Roll.vue?vue&type=style&index=0&id=695e0975&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695e0975",
  null
  
)

export default component.exports